import React, { useState, useEffect } from "react";
import { Box, Grid, Button, Typography, Link } from "@mui/material";
import CookieConsentModal from "./CookiesModel";

const CookieConsent = () => {
    const [showBanner, setShowBanner] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("cookieConsent");
        if (!consent) {
            setShowBanner(true);
        }
    }, []);

    const handleAccept = () => {
        const preferences = {
            necessary: true,
            functional: true,
            performance: true,
            targeting: true,
        };

        localStorage.setItem(
            "cookieConsent",
            JSON.stringify(preferences)
        );

        setShowBanner(false);

        window.dispatchEvent(new Event("cookieConsentUpdated"));
    };

    const handleManageCookies = () => {
        alert("Redirect to manage cookies settings.");
    };

    if (!showBanner) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                bottom: 0,
                left: 0,
                width: "100%",
                minHeight: "100px",
                backgroundColor: "white",
                boxShadow: "0px -2px 10px rgba(0,0,0,0.1)",
                padding: { xs: "24px", md: "24px 48px" },
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                zIndex: 1000,
                borderRadius: "12px 12px 0px 0px"
            }}
        >
            <Typography sx={{ fontSize: { xs: "14px", md: "18px" }, mb: 2, fontWeight: 600, color: "#000" }}>
                We Value Your Privacy
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                    <Typography sx={{ fontSize: { xs: "12px", md: "15px" }, color: "#7A7A7A" }}>
                        Our EHS & ESG solutions help you manage all processes and compliance.
                        Mitigate risks and take the right actions for your net zero journey.{" "}
                        <Link href="/privacy-policy" sx={{ textDecoration: "underline", color: "#000" }}>
                            Privacy Statement
                        </Link>
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                    <Box sx={{ display: "flex", justifyContent: { xs: "space-between;", md: "flex-end" }, gap: "10px" }}>
                        <Button variant="text" sx={{ color: "#0044cc", textDecoration: "underline", }} onClick={() => setOpen(true)}>
                            Manage Cookies
                        </Button>
                        <Button variant="contained" sx={{ bgcolor: "#07329F", textTransform: "none" }} onClick={handleAccept}>
                            Accept All Cookies
                        </Button>
                    </Box>
                </Grid>

            </Grid>

            <CookieConsentModal
                open={open}
                handleClose={() => setOpen(false)}
                onSave={(preferences) => {
                    localStorage.setItem(
                        "cookieConsent",
                        JSON.stringify(preferences)
                    );

                    setShowBanner(false);
                    setOpen(false);

                    window.dispatchEvent(
                        new Event("cookieConsentUpdated")
                    );
                }}
            />
        </Box>
    );
};

export default CookieConsent;
